module.exports = __webpack_public_path__ + "static/image/history/m/201911@3x.jpg?3ccf0aea";